<template>
  <div class="box7">
    <pageTitle title="学员掠影" />
    <div class="subject-box">
      <swiper :options="swiperOption" ref="mySwiper" class="swiperitems">
        <swiper-slide
          class="swiperwrap"
          v-for="(item, index) in listSwiper"
          :key="index"
        >
          <div class="box">
            <img :src="item.img" alt="" />
          </div>
        </swiper-slide>
      </swiper>
      <div class="swiper-pagination-box7"></div>
    </div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
export default {
  components: {
    pageTitle,
    swiper,
    swiperSlide,
  },
  data() {
    return {
      swiperOption: {
        loop: true, // 循环模式选项
        slidesPerView: "auto",
        spaceBetween: 20,
        slidesPerView: "auto",
        autoplay: true,
        centeredSlides: true,
        pagination: {
          el: ".swiper-pagination-box7",
        },
      },
      listSwiper: [
        {
          img: require("../../../assets/coursePage/nau/box7/img01.png"),
        },
        {
          img: require("../../../assets/coursePage/nau/box7/img02.png"),
        },
        {
          img: require("../../../assets/coursePage/nau/box7/img03.png"),
        },
      ],
    };
  },

  methods: {},
};
</script>

<style  lang="less" scoped>
.box7 {
  padding: 80px 0;
  background: #eaf3fd;
  width: 100%;
  .subject-box {
    padding: 0 32px;
    position: relative;
    margin: 48px auto 0;
    // padding-bottom: 22px;

    overflow: hidden;
    border-radius: 20px;
    overflow: hidden;
    .swiper-container{
      margin-bottom: 32px;
    }
    .swiper-slide {
      border-radius: 20px;
    }

    .swiper-pagination-box7 {
      display: flex;
      align-items: center;
      position: absolute;
      left: 50%;
      bottom: 0px;
      transform: translate(-50%, 0px);
      height: 6px;
    
    }

    /deep/ .swiper-pagination-bullet {
      width: 12px;
      height: 6px;
      background: rgba(75, 132, 250, 0.36);
      border-radius: 3px;
      margin-right: 8px;
    }
    /deep/ .swiper-pagination-bullet:last-child {
      margin-right: 0px;
    }

    /deep/.swiper-pagination-bullet.swiper-pagination-bullet-active {
      width: 24px;
      height: 6px;
      background: #4b84fa;
      border-radius: 3px;
    }

    .swiper-slide {
      width: 100%;
      display: flex;
      justify-content: center;

      box-sizing: border-box;
      .box {
        width: 100%;
        // height: 512px;
        img {
          width: 100%;
        }
      }
    }
  }
}
</style>
